// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file_2E3ae","file__inner":"File_file__inner_d_BIO"};